import PropTypes from 'prop-types'

import BreadcrumbItem from 'components/BreadcrumbItem'

import { Crumb, Crumbs, Root } from './Breadcrumb.style'

const Breadcrumb = ({ crumbs = [] }) => {
  return (
    <Root aria-label="Breadcrumb">
      <Crumbs>
        <Crumb>
          <BreadcrumbItem url="/shop" title="Shop" />
        </Crumb>
        {crumbs.map((crumb, index) => (
          <Crumb key={index}>
            <BreadcrumbItem {...crumb} current={index === crumbs.length - 1} />
          </Crumb>
        ))}
      </Crumbs>
    </Root>
  )
}

Breadcrumb.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    })
  ),
}

Breadcrumb.defaultProps = {
  crumbs: [],
}

export default Breadcrumb
